export default __webpack_public_path__ + "static/media/singapore-flow.c2d1dab1.jpg";